module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('b', [_vm._v("1621")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter0"
  }, [_vm._v("Slide Rule")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent_line"
  }, [_c('b', [_vm._v("John Napier")]), _vm._v(" (1550–1617)"), _c('b', [_vm._v(", Edmund Gunter")]), _vm._v(" (1581–1626)"), _c('b', [_vm._v(", William Oughtred")]), _vm._v(" (1574–1660)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("If you place two ordinary rulers alongside each other, with the start of one ruler located at the 5 of the other, then the two scales can be used to rapidly compute the result of adding the number 5 to any number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In its simplest form, the slide rule does the same thing, except the numbers that are added are printed on two logarithmic scales, so adding to the distance actually multiplies the numbers. Accuracy is limited to roughly three digits, although large slide rules can be accurate to four. Logarithms answer the question of how many times one number must be multiplied to get another number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Building the slide rule required three key inventions. The first was the discovery of the logarithm function itself by John Napier, a Scottish nobleman. Napier developed a mechanical device now called "), _c('i', [_vm._v("Napier’s bones,")]), _vm._v(" which allowed multiplication and division of multi-digit numbers by any other number between 2 and 9. He also wrote a seminal book on logarithms after realizing they could be used to reduce the burden of computation. Napier’s book had 57 pages of text and 90 pages of numeric tables. He published this treatise in 1614, just three years before his death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shortly after Napier’s publication, Edmund Gunter, an English mathematician and clergyman, created a wooden device that resembled a ruler that had multiple scales. One of those scales, labeled NUM, was logarithmic. At the ends of the scales were brass pins, where the point of a compass could be rested. Using a compass to measure distance, one could mechanically measure two distances and add the distances together, making it straightforward to calculate a product. William Oughtred, an English mathematician and Anglican minister, realized that Gunter’s invention could be made far more useful by combining two sliding rules. His early 1630 device was circular; by the 1650s, he had devised the modern slide rule, with two fixed scales and a sliding rule between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Portable, practical, and not terribly difficult to master, the slide rule became both a standard tool of calculation and a potent symbol for the numerically minded engineer. Even after the invention of the electronic computer, slide rules dominated in schools and the workplace until the development of portable electronic calculators in the 1970s.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c048_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curta Calculator (1948)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c122_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HP-35 Calculator (1972)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("Slide rules, such as those pictured here from the MIT Slide Rule Collection, remained popular until the invention of the portable electronic calculator.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/31-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b61894d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c008_r1.vue
// module id = 96
// module chunks = 0